import RfxEvaluationStyles from "./RfxEvaluationDashboard.module.scss";
import Container from "../../../../components/Cards/Container/Container";
import Typography from "../../../../components/Typography/Typography";

import rightArrowSvg from "../../../../assets/ArrowForwardFilled.svg";
import rightArrowSvgDisabled from "../../../../assets/images/right_arrow.svg";
import sourceHeaderSvg from "../../../../assets/sources_header.svg";
import infoIconSvg from "../../../../assets/images/UserTable/InfoIcon.svg";
import PlusSvg from "../../../../assets/images/plus_icon.svg";
import PdfSvg from "../../../../assets/pdfIcon.svg";

import { Avatar } from "@mui/material";
import UploadDoc from "../../../../components/UploadDoc/UploadDoc";
import Button from "../../../../components/Button/Button";
import { DASHBOARD_ENTITIES } from "../../../../common/constants";
import Table from "../../../../components/Table/Table";
import { TableTypes } from "../../../ManageContract/constants";
import { useAppDispatch, useAppSelector } from "../../../../hooks/store";
import { Checkbox } from "antd";
import { evaluateRfxDocuments } from "../../dashboard.service";
import { updateRfxEvaluationData } from "../../store/dashboard.thunk";
import { getToast } from "../../../../common/utils";
import { getTableDataThunk } from "../../../../store/thunks/table.thunk";
import { useEffect, useState } from "react";
import Tooltip from "../../../../components/Tooltip/Tooltip";
import { IUploadedDocsForRFxEvaluation } from "../../types";

const RfxEvaluationDashboard = (props: any) => {
  const [openModal, setOpenModal] = useState(false);
  const dispatch = useAppDispatch();

  const { rfxEvaluation } = useAppSelector(
    (store) => store.rootReducer.vscDashboardReducer
  );
  const {
    docsUploading,
    docs,
    docsUploaded,
    selectedDocuments,
    evaluatingRfx,
  } = rfxEvaluation;

  const tableData = useAppSelector(
    (store) => store?.rootReducer?.tableInfoReducer
  )?.data?.[TableTypes.RFX_EVALUATION_DASHBOARD];

  const page = tableData?.page || 1;
  const count = tableData?.toBeRetrieved || 10;

  const tableDataInData = tableData?.tableData;
  const tableDataCount = tableDataInData?.count;

  const enableEvaluateRfxButton =
    docsUploaded &&
    docs?.rfx_files?.length > 0 &&
    selectedDocuments?.rfx_files?.length > 0;

  const postEvaluationCleanUp = () => {
    dispatch(
      updateRfxEvaluationData({
        docsUploading: false,
        docs: [],
        docsUploaded: false,
        selectedDocuments: [],
        evaluatingRfx: false,
      })
    );
  };

  const evaluateRfx = async () => {
    dispatch(
      updateRfxEvaluationData({
        evaluatingRfx: true,
      })
    );
    try {
      await evaluateRfxDocuments(selectedDocuments);
      postEvaluationCleanUp();
      dispatch(
        getTableDataThunk(TableTypes.RFX_EVALUATION_DASHBOARD, page, count)
      );
      getToast("Success", "RFx have been evaluated");
    } catch (error: any) {
      const errorMessage = error?.response?.data?.status_message;
      getToast("Error", errorMessage || "RFx couldn't be evaluated");
    } finally {
      dispatch(
        updateRfxEvaluationData({
          evaluatingRfx: false,
        })
      );
    }
  };

  return (
    <Container className={RfxEvaluationStyles.customContainer}>
      <div className={RfxEvaluationStyles.cdContainer}>
        <div className={RfxEvaluationStyles.rfxEvaluationActionsContainer}>
          <div className={RfxEvaluationStyles.leftContainer}>
            <div className={RfxEvaluationStyles.leftHeader}>
              <div className={RfxEvaluationStyles.draftingIcon}>
                <img src={sourceHeaderSvg} alt="" height={24} width={24} />
                <Typography fontWeight={700} fontSize={12} color="#3474E0">
                  Sources
                </Typography>
                <Tooltip
                  title="Upload your product RFP, scorecard, and responses together — include at least one RFx (file name ending with RFI/RFP) file and one RFx Response file."
                  placement="right"
                >
                  <img src={infoIconSvg} alt="" height={12} width={12} />
                </Tooltip>
              </div>
            </div>
            <div className={RfxEvaluationStyles.leftCardContent}>
              <Button
                style={{
                  borderRadius: "24px",
                  width: "90%",
                  fontWeight: "400",
                  fontSize: "12px",
                  padding: "6px",
                }}
                fullWidth={true}
                variant="outlined"
                // startIcon={<img src={PlusSvg} alt="" />}
                onClick={() => setOpenModal(true)}
                disabled={
                  evaluatingRfx ||
                  docsUploading ||
                  (docsUploaded && docs?.rfx_files?.length > 0)
                }
              >
                + Add Source
              </Button>
            </div>
            <div className={RfxEvaluationStyles.selectResourcesWrapper}>
              <SelectResourcesAndEvaluate
                docs={docs}
                docsUploading={docsUploading}
                selectedDocuments={selectedDocuments}
                evaluatingRfx={evaluatingRfx}
              />
              <div className={RfxEvaluationStyles.generateButtonWrapper}>
                <Button
                  style={{
                    borderRadius: "24px",
                    width: "98%",
                    fontWeight: "400",
                    fontSize: "12px",
                    padding: "4px 12px",
                  }}
                  fullWidth={true}
                  className={RfxEvaluationStyles.generateButton}
                  disabled={!enableEvaluateRfxButton}
                  startIcon={
                    <img
                      src={
                        !enableEvaluateRfxButton
                          ? rightArrowSvgDisabled
                          : rightArrowSvg
                      }
                      alt=""
                    />
                  }
                  loading={evaluatingRfx}
                  onClick={evaluateRfx}
                >
                  Evaluate RFx
                </Button>
              </div>
            </div>
          </div>
        </div>
        <div className={RfxEvaluationStyles.rfxEvalutationTableContainer}>
          <div className={RfxEvaluationStyles.headerRightSide}>
            <Avatar
              style={{
                width: "42px",
                height: "42px",
                fontSize: "16px",
                fontWeight: "500",
                fontFamily: "Google Sans",
                backgroundColor: "#0E9D580D",
                color: "#00796B",
                border: "1px solid #0E9D58",
              }}
            >
              {tableDataCount || 0}
            </Avatar>
            <span className={RfxEvaluationStyles.headerText}>
              <Typography fontWeight={500} fontSize={14} color="#3474e0">
                All Evaluated RFx
              </Typography>
              <Typography
                fontWeight={400}
                fontSize={12}
                color="#00000099"
                className={RfxEvaluationStyles.subHeaderText}
              >
                Number of evaluated RFx
              </Typography>
            </span>
          </div>
          <div style={{ height: "85%" }}>
            <Table entity={TableTypes.RFX_EVALUATION_DASHBOARD} apiProps={{}} />
          </div>
        </div>
      </div>
      <UploadDoc
        openModal={openModal}
        setOpenModal={setOpenModal}
        dashboardEntity={DASHBOARD_ENTITIES.RFX_EVALUATION}
      />
    </Container>
  );
};

const SelectResourcesAndEvaluate = ({
  docs,
  docsUploading,
  selectedDocuments,
  evaluatingRfx,
}: {
  docs: IUploadedDocsForRFxEvaluation;
  docsUploading: boolean;
  selectedDocuments: IUploadedDocsForRFxEvaluation;
  evaluatingRfx: boolean;
}) => {
  const dispatch = useAppDispatch();
  const handleSelectAllChange = (e: any) => {
    const checked = e.target.checked;
    let documents: IUploadedDocsForRFxEvaluation = {
      rfx_files: [],
    };
    dispatch(
      updateRfxEvaluationData({
        selectedDocuments: checked ? docs : documents,
      })
    );
  };

  useEffect(() => {
    // When docs are loaded and not uploading anymore, select all documents
    if (docs?.rfx_files?.length > 0 && !docsUploading) {
      dispatch(
        updateRfxEvaluationData({
          selectedDocuments: {
            ...selectedDocuments,
            rfx_files: [...docs.rfx_files],
          },
        })
      );
    }
  }, [docs?.rfx_files, docsUploading]);

  const handleDocumentChange = (id: number, checked: boolean) => {
    let documents: IUploadedDocsForRFxEvaluation = { ...selectedDocuments };

    if (checked) {
      const docIdx = docs?.rfx_files.findIndex(
        (doc: any) => doc?.file_id_db === id
      );

      const docCopy = documents.rfx_files?.slice() || [];
      docCopy.push(docs.rfx_files[docIdx]);
      if (docIdx > -1) {
        documents = {
          ...documents,
          rfx_files: docCopy,
        };
      }
    } else {
      const docIdx = selectedDocuments?.rfx_files.findIndex(
        (doc: any) => doc?.file_id_db === id
      );

      const docCopy = documents.rfx_files?.slice() || [];
      docCopy.splice(docIdx, 1);
      if (docIdx > -1) {
        documents = {
          ...documents,
          rfx_files: docCopy,
        };
      }
    }

    dispatch(
      updateRfxEvaluationData({
        selectedDocuments: documents,
      })
    );
  };

  return (
    <div className={RfxEvaluationStyles.selectOptionsContainer}>
      {docs?.rfx_files?.length > 0 && (
        <div className={RfxEvaluationStyles.selectFileOption}>
          <Checkbox
            checked={
              selectedDocuments?.rfx_files?.length === docs?.rfx_files?.length
            }
            onChange={handleSelectAllChange}
            style={{
              marginBottom: "1.2rem",
            }}
            disabled={evaluatingRfx || docsUploading}
          >
            <Typography fontSize="11px" fontWeight={400} color="#1E1E1E">
              Select all sources
            </Typography>
          </Checkbox>
        </div>
      )}
      <div className={RfxEvaluationStyles.optionsContainer}>
        {docs?.rfx_files?.map((document: any) => {
          return (
            <div
              className={`${RfxEvaluationStyles.selectFileOption} ${
                docsUploading ? RfxEvaluationStyles.loadingRows : ""
              }`}
            >
              <Checkbox
                checked={
                  selectedDocuments?.rfx_files?.findIndex(
                    (selectedDoc: any) =>
                      selectedDoc?.file_id_db === document?.file_id_db
                  ) > -1
                }
                onChange={(e) =>
                  handleDocumentChange(document?.file_id_db, e.target.checked)
                }
                disabled={docsUploading || evaluatingRfx}
              >
                <Tooltip title={document?.file_name}>
                  <div>
                    <Typography
                      fontSize="11px"
                      fontWeight={400}
                      color="#1E1E1E"
                      style={{
                        maxWidth: "180px",
                        minWidth: "180px",
                        width: "auto",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {document?.file_name}
                    </Typography>
                  </div>
                </Tooltip>
              </Checkbox>
              <img src={PdfSvg} alt="" />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RfxEvaluationDashboard;
